import React from 'react';
import { StatusData } from "../types/StatusData";
import { StatusItem } from "./StatusItem";

/**
 * ステータスのコンテンツを生成
 * @param statuses 
 * @returns JSX.Element[]
 */
export const RenderStatusContents = (statuses: StatusData[]): JSX.Element[] => {
  return statuses.map(({ timestamp, status }, index) => (
    <StatusItem key={index} timestamp={timestamp} status={status} />
  ));
}
